import { render, staticRenderFns } from "./Passkeys.vue?vue&type=template&id=2172817a&scoped=true&lang=pug&"
import script from "./Passkeys.vue?vue&type=script&lang=ts&"
export * from "./Passkeys.vue?vue&type=script&lang=ts&"
import style0 from "./Passkeys.vue?vue&type=style&index=0&id=2172817a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2172817a",
  null
  
)

export default component.exports